import { types, actions } from './requests'
export const CREATETIMECALENDAR_TYPES = {
    ...types('CREATETIMECALENDAR'),
}
export const CREATETIMECALENDAR_ACTIONS = {
    ...actions('CREATETIMECALENDAR'),
}